export default {
  minute: {
    zero: "لا يوجد دقائق",
    one: "دقيقة واحدة",
    two: "دقيقتان",
    few: "{n} دقائق",
    many: "{n} دقيقة",
  },
  call: {
    zero: "لا مكالمات",
    one: "مكالمة واحدة",
    two: "مكالمتان",
    few: "{n} مكالمات",
    many: "{n} مكالمة",
  },
  status: {
    zero: "لا يوجد حالة",
    one: "حالة واحدة",
    two: "حالتان",
    few: "{n} حالات",
    many: "{n} حالة",
  },
  user: {
    zero: "لا يوجد مستخدمين",
    one: "مستخدم واحد",
    two: "مستخدمان",
    few: "{n} مستخدمين",
    many: "{n} مستخدم",
  },
  agent: {
    zero: "لا يوجد موظف",
    one: "موظف واحد",
    two: "موظفان",
    few: "{n} موظفين",
    many: "{n} موظف",
  },
  conversation: {
    zero: "لا توجد محادثة",
    one: "محادثة واحدة",
    two: "محادثتان",
    few: "{n} محادثات",
    many: "{n} محادثة",
  },
};
